//-------------------- Home page pr svg animation jq ----------------------
$(document).ready(function() {
  // Initialize variables
  var textPath = $('.Marquee-svg-text')[0];
  var textLength = textPath.getComputedTextLength();
   var curveLength = $('#curve')[0].getTotalLength();
   var offset = -curveLength; // Initialize with negative value to start from the end
  // var offset = curveLength - textLength; // Adjust initial offset
  // Set initial start offset
  textPath.setAttribute('startOffset', offset);

  // Function to update start offset
  function updateOffset() {
    offset--;
    if (offset < -textLength) {
      offset = curveLength;
    }
    textPath.setAttribute('startOffset', offset);
  }

  // Update offset periodically for scrolling effect
  setInterval(updateOffset, 15); // Adjust speed as needed  
});


$(document).ready(function() {
  if($(window).width() <= 767){   
    $('.Marquee-svg-text tspan').each(function() {
      
      // Get the value from the input field
      var number = parseFloat($(this).attr('x'));
      
        // Halve the number
        var halvedNumber = number / 2.2;
      
        // Display the result
         $(this).attr('x', halvedNumber);   
    });
  }

// -------------------mobile slider js-----------------
if ($(window).width() <= 767) {
$('.custom-index-section .custom-slider-test').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<div class="slick-arrow prev"><svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke-width="2" color="currentColor"><path d="M18.5 12H6m0 0l6-6m-6 6l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
   nextArrow: '<div class="slick-arrow next"><svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" color="currentColor"><path d="M6 12h12.5m0 0l-6-6m6 6l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
  dots: false,
  infinite: false,
});

}




  
});  


// Third party links open in a new tab 
  $(function() {
	$('a').filter(function() {
		return this.hostname && this.hostname !== location.hostname;
	}).attr('target', '_blank');
  });

